import { render, staticRenderFns } from "./QuestionSingle2.vue?vue&type=template&id=e398e41e&scoped=true&"
import script from "./QuestionSingle2.vue?vue&type=script&lang=js&"
export * from "./QuestionSingle2.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSingle2.vue?vue&type=style&index=0&id=e398e41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e398e41e",
  null
  
)

export default component.exports